import { useEffect, useState } from "react";
import { fetchKanbanWorkLogs } from "../api/fetchWorkLogs";
import { KanbanWorkLog } from "../models/workLog";

export function useKanbanWorkLog(occurrenceId: string) {
    const [loading, setLoading] = useState(false);
    const [workLogs, setWorkLogs] = useState<KanbanWorkLog[]>([]);
    const [page, setPage] = useState<number>(0);
    const [size, ] = useState(5);
    const [hasMoreData, setHasMoreData] = useState(true);

    const [filters, setFilters] = useState({
        step: '',
        user: '',
        dateStart: '',
        dateEnd: '',
      });

    useEffect(() => {
        getWorkLogs();
    }, [occurrenceId]);

    const getWorkLogs = async (localPage: number = page) => {
        setLoading(true);
        const data = await fetchKanbanWorkLogs(occurrenceId, filters, localPage, size);
        
        if(data.length < size) {
            setHasMoreData(false);
        }
        setWorkLogs([
            ...(localPage === 0 ? [] : workLogs),
            ...data,
        ]);
        setPage(localPage + 1);
        setLoading(false);
    }

    const resetPage = () => {
        getWorkLogs(0);
    }

    const loadMore = () => {
        getWorkLogs();
    }

    const resolveEnumsLog = (value: string): string => {
        const enumMapping: { [key: string]: string } = {
            'WAITING_DEALERSHIP': 'Aguardando Concessionária',
            'UNAVAILABLE': 'Indisponível',

            // Boolean values
            'true': 'Sim',
            'yes': 'Sim',
            'y': 'Sim',
            'no': 'Não',
            'n': 'Não',
            'false': 'Não',
        }

        return enumMapping[value] || value;
    }

    return { workLogs, loading, loadMore, hasMoreData, filters, setFilters, resetPage, resolveEnumsLog };
}